import QuickJobsApi from '.';

class Stats {
  protected client: QuickJobsApi;
  constructor(client: QuickJobsApi) {
    this.client = client;
  }

  public getPlaceStats() {
    return this.client.httpClient.get('/stats/places');
  }

  public getGeneralStats(stepBy?: 'day' | 'week' | 'month', from?: Date, to?: Date) {
    return this.client.httpClient.get('/stats/general', {
      params: {
        stepBy: stepBy,
        from: from ? from.toISOString() : undefined,
        to: to ? to.toISOString() : undefined,
      },
    });
  }
}

export default Stats;



// WEBPACK FOOTER //
// ./src/libs/quickjobs-api/stats.ts